var _mask, _rect, _rect2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDriveThruIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-18.00 -25.50 120.00 120.00",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "dtm",
    maskUnits: "userSpaceOnUse",
    x: -18,
    y: -25.5,
    width: 120,
    height: 120
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,10 a10,10 0 0 1 10,-10 h26 l10,16 h28 a10,10 0 0 1 10,10 v22 a10,10 0 0 1 -10,10 h-64 a10,10 0 0 1 -10,-10 z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 58,
    r: 13.5,
    fill: "#000"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 58,
    r: 11,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 58,
    r: 7.5,
    fill: "#000"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 22,
    y1: 50.4,
    x2: 22,
    y2: 65.6,
    stroke: "#fff",
    strokeWidth: 2.8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 28.582,
    y1: 54.2,
    x2: 15.418,
    y2: 61.8,
    stroke: "#fff",
    strokeWidth: 2.8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 28.582,
    y1: 61.8,
    x2: 15.418,
    y2: 54.2,
    stroke: "#fff",
    strokeWidth: 2.8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 58,
    r: 3.2,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 58,
    r: 13.5,
    fill: "#000"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 58,
    r: 11,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 58,
    r: 7.5,
    fill: "#000"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 64,
    y1: 50.4,
    x2: 64,
    y2: 65.6,
    stroke: "#fff",
    strokeWidth: 2.8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 70.582,
    y1: 54.2,
    x2: 57.418,
    y2: 61.8,
    stroke: "#fff",
    strokeWidth: 2.8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 70.582,
    y1: 61.8,
    x2: 57.418,
    y2: 54.2,
    stroke: "#fff",
    strokeWidth: 2.8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 58,
    r: 3.2,
    fill: "#fff"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -18,
    y: -25.5,
    width: 120,
    height: 120,
    rx: 24,
    fill: "#2563eb"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -18,
    y: -25.5,
    width: 120,
    height: 120,
    fill: "#ffffff",
    mask: "url(#dtm)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDriveThruIcon);
export default __webpack_public_path__ + "static/media/drive-thru-icon.74f9e613813f0e2c498a4f9568af0419.svg";
export { ForwardRef as ReactComponent };